import React from "react";
import "./NosServices.css";
import digital from "../../../assets/images/digital.png";
import Vector from "../../../assets/images/Vector.png";
import insertion from "../../../assets/images/insertion.png";
import visite from "../../../assets/images/visite.png";
import { Link } from "react-router-dom";

const NosServices = () => {
  return (
    <div className="service-section">
      <h2 className="service-title animate-fade-in">
        <span className="service-corner service-top-left" />
        <span className="service-corner service-top-right" />
        Nos Services
        <span className="service-corner service-bottom-left" />
        <span className="service-corner service-bottom-right" />
      </h2>

      <div className="service-grid">
        <div className="service-card animate-slide-in-left">
          <img src={visite} alt="visite" className="service-icon" />
          <h3>Visites d’affaires en Amérique du Nord</h3>
          <p className="service-description">
            Nous organisons des programmes sur mesure pour favoriser les
            échanges B2B entre les entrepreneurs malagasy et les écosystèmes
            innovants des États-Unis et/ou du Canada, avec deux formats
            possibles :
            <br />
            Visite d’Exploration (7 à 14 jours)
            <br />
            <br />
            Visite d’Immersion professionnelle (4 semaines ou +)
          </p>
          <div className="service-card-footer">
            <Link to="/visiteaffaire" className="service-follow-link">
              <span className="service-arrow">→</span>
            </Link>
          </div>
        </div>

        <div className="service-card animate-slide-in-right">
          <img src={digital} alt="digital" className="service-icon" />
          <h3>
            Transformation Digitale
            <br />
            pour PME et Startups
          </h3>
          <p className="service-description">
            Stratégies UX/UI, Refonte de site web & SEO pour booster votre
            présence en ligne et votre croissance.
            <br />
            <br />
            Passez au digital dès aujourd’hui.
          </p>
          <div className="service-card-footer">
            <Link to="/transformation" className="service-follow-link">
              <span className="service-arrow">→</span>
            </Link>
          </div>
        </div>

        <div className="service-card animate-slide-in-bottom">
          <img src={Vector} alt="vector" className="service-icon" />
          <h3>Outils numériques pour la performance</h3>
          <p className="service-description">
            Solutions digitales pour structurer, normaliser et optimiser vos
            processus.
            <br />
            <br />
            Réduisez les gaspillages, gagnez en efficacité.
          </p>
          <div className="service-card-footer">
            <Link to="/outilNumerique" className="service-follow-link">
              <span className="service-arrow">→</span>
            </Link>
          </div>
        </div>

        <div className="service-card animate-slide-in-left">
          <img src={insertion} alt="insertion" className="service-icon" />
          <h3>
            Employabilité et insertion
            <br />
            professionnelle - avec e-asa
          </h3>
          <p className="service-description">
            Coaching, parcours personnalisés, stages et offres d’emploi pour
            connecter les talents malagasy aux opportunités locales et
            internationales.
            <br />
            <br />
            Explorez de nouvelles opportunités.
          </p>
          <div className="service-card-footer">
            <Link to="/employabilite" className="service-follow-link">
              <span className="service-arrow">→</span>
            </Link>
          </div>
        </div>
      </div>
      <div>
        <button
          className="service-btn-rejoindre"
          onClick={() => (window.location.href = "/contact")}
        >
          REJOIGNEZ-NOUS POUR <br /> UNE CONSULTATION GRATUITE
        </button>
      </div>
    </div>
  );
};

export default NosServices;

